import { Code as MantineCode, CodeProps } from '@mantine/core';

export type ICodeProps = CodeProps;

/** @registry Design-layer pass-through over Mantine Code; import this instead of @mantine/core Code outside src/design. */
export const Code = MantineCode;
